import { endpoints } from './endpoints';

export const environment = {
    name: 'prod',
    develop: false,
    production: true,
    api: { base: 'https://api.cloud.ai4eosc.eu/v1', endpoints },
    huggingFaceClientSecret: 'd7c7c946-b727-48f5-a28a-f9c487f4e8af',
};
